import { Box, Heading, Stack, VStack } from '@chakra-ui/react';
import React from 'react';
import Notifications from '../components/Dashboard/Notifications';

const NotificationsPage = () => {
  return (
    <VStack px={{ base: 4, md: 10 }} py={8} spacing={{ base: 4, md: 8 }}>
      <Box w={'full'}>
        <Heading>Notifications</Heading>
      </Box>
      <Stack
        w={'full'}
        h={'full'}
        spacing={{ base: 0, xl: 4 }}
        direction={'row'}
        sx={{ h: 'calc(100vh - 260px)' }}
      >
        <Notifications standAlone={true} />
      </Stack>
    </VStack>
  );
};

export default NotificationsPage;
